import classNames from 'classnames';
import React from 'react';
import './styles/MainHeaderNavBar.scss';
import { MainHeaderNavBarItem } from './MainHeaderNavBarItem';

export interface MenuItem {
    hasDropdown: boolean;
    navigationId: string;
    url: string;
    label: string;
    name: string;
    isExternal: boolean;
    tag: string;
    isSelected: boolean;
    attributes?: React.HTMLAttributes<HTMLLIElement>;
}

interface MainHeaderNavBarProps {
    hoveredMainHeaderNavId: string;
    menuItems: MenuItem[];
    onLinkHover?: (menuItem: MenuItem) => void;
    onLinkClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, menuItem: MenuItem) => void;
    className?: string;
}

function MainHeaderNavBar({
    hoveredMainHeaderNavId,
    menuItems,
    onLinkHover,
    onLinkClick,
    className,
}: MainHeaderNavBarProps) {
    const classes = classNames('main-header-nav-bar', className);

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, menuItem: MenuItem) => {
        onLinkClick?.(event, menuItem);
    };

    const handleLinkHover = (menuItem: MenuItem) => {
        onLinkHover?.(menuItem);
    };

    return (
        <ul className={classes}>
            {menuItems.map((menuItem, index) => (
                <MainHeaderNavBarItem
                    key={menuItem.navigationId}
                    index={index}
                    isDropdownOpen={hoveredMainHeaderNavId === menuItem.navigationId}
                    menuItem={menuItem}
                    onClick={handleClick}
                    onLinkHover={handleLinkHover}
                />
            ))}
        </ul>
    );
}

export default MainHeaderNavBar;
